import { parse, stringify } from 'query-string';
import { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import { Note } from '../../../helbest';
import { API } from '../../../request/api';
import useCategoryBar from '../../components/CategoryBar/useCategoryBar';

export const getSortedParams = (params) =>
  [
    params.id || null,
    params.sub || null,
    params.c3 || null,
    params.c4 || null,
    params.c5 || null,
    params.c6 || null
  ].filter((catItem) => catItem !== null);

const useCategoy = (Login) => {
  const history = useHistory();
  const params = useParams();
  const paramsArray = getSortedParams(params);
  const location = useLocation();
  const queryParams = parse(location.search);
  const [showCategoryTab, setShowCategoryTab] = useState(false);
  const [list, set_list] = useState([]);
  const [layouts, setLayouts] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [adv_list, set_adv_list] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [banner_list, set_banner_list] = useState([]);
  const [isHomeCategory, setIsHomeCategory] = useState(null);
  const [isLayoutReqFinished, setIsLayoutReqFinished] = useState(false);

  const catgBar = useCategoryBar();

  // const getAdvers = () => {
  //   API.get
  //     .layout(
  //       Login.city_id,
  //       catgBar.activeCategory,
  //       !window.matchMedia('(min-width: 600px)').matches,
  //       'category_page'
  //     )
  //     .then((response) => {
  //       if (response.success) {
  //         const allSliders = response.data.flatMap((item) => item.banners);
  //         set_adv_list(allSliders);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error('Error : ', error);
  //     });
  // };

  // const getSlider = () => {
  //   if (Login.city_id !== '' && catgBar.activeCategory) {
  //     API.get
  //       .layout(Login.city_id, catgBar.activeCategory, false)
  //       .then((response) => {
  //         if (response.success) {
  //           const allProductSliders = response.data.flatMap((item) => item.sliders);
  //           set_banner_list(allProductSliders);
  //         }
  //       })
  //       .catch((error) => {
  //         console.error('Error : ', error);
  //       });
  //   }
  // };

  const getLayoutSections = () => {
    if (catgBar.activeCategory !== null) {
      API.get
        .layout(Login.city_id, catgBar.activeCategory, 'home_page', true)
        .then((response) => {
          if (response.success) {
            if (paramsArray[paramsArray.length - 1] === paramsArray[paramsArray.length - 2]) {
              API.get
                .layout(Login.city_id, catgBar.activeCategory, 'category_page', true)
                .then((response2) => {
                  if (response2.success) {
                    setLayouts(response2.data);
                    setIsHomeCategory(false);
                  }
                  return response2;
                })
                .catch((error) => {
                  // eslint-disable-next-line no-console
                  console.error('Error : ', error);
                });
            } else if (response.data.length !== 0) {
              setLayouts(response.data);
              setIsHomeCategory(true);
            } else {
              API.get
                .layout(Login.city_id, catgBar.activeCategory, 'category_page', true)
                .then((response3) => {
                  if (response3.success) {
                    setLayouts(response3.data);
                    setIsHomeCategory(false);
                  }
                  return response3;
                })
                .catch((error) => {
                  // eslint-disable-next-line no-console
                  console.error('Error : ', error);
                });
            }
          }
          return response;
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error('Error : ', error);
        });
    }
    setIsLayoutReqFinished(true);
  };

  const getData = () => {
    set_list([]);

    const parsed_query = parse(history.location.search);

    const new_query = {};

    Object.keys(parsed_query).map((query_key) => {
      if (query_key === 'sort') {
        new_query.sort = parsed_query.sort;
      } else {
        new_query[query_key] = parsed_query[query_key];
      }
      return null;
    });

    const query = history.location.search === '' ? '' : `&${stringify(new_query)}`;

    if (catgBar.activeCategory !== null) {
      API.get
        .products(Login.city_id, catgBar.activeCategory, query)
        .then((response) => {
          set_list(response.data);
          const elm = document.getElementById(history.location.hash.substr(1));
          if (elm) {
            elm.scrollIntoView();
          }
          return response;
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error('Error : ', error);
        });
    } else {
      set_list([]);
    }
  };

  const sliderClickHandler = (x) => {
    if (x.url !== null) {
      if (x.url?.substr(0, 4) === 'http') {
        window.location.replace(x.url);
      } else {
        history.push(x.url);
      }
    }
  };

  useEffect(() => {
    if ((Login.city_id || Login.province_id) && catgBar.activeCategory !== null) {
      // getAdvers();
      // getSlider();
      getLayoutSections();
    }
  }, [Login?.city_id, catgBar.activeCategory]); // eslint-disable-line

  useEffect(() => {
    if (isLayoutReqFinished === true) {
      getData();
    }
  }, [history.location.search, Login.city_id, catgBar.activeCategory, isLayoutReqFinished]); // eslint-disable-line

  // we dont need this part for carfillo
  // useEffect(() => {
  //   getAdvers();
  //   getSlider();
  // }, []); // eslint-disable-line

  useEffect(() => {
    if (queryParams.product_id && list.length > 0) {
      const mismatchedProduct = list.find(
        (data) => data.product_id === Number(queryParams.product_id)
      );
      if (!mismatchedProduct) {
        Note.error('محصولی یافت نشد.');
      }
    }
  }, [list.length, queryParams.product_id]); // eslint-disable-line

  return {
    showCategoryTab,
    list,
    layouts,
    isHomeCategory,
    setShowCategoryTab,
    sliderClickHandler,
    params,
    adv_list,
    banner_list
  };
};

export default useCategoy;
